<div class="fd-modal__container">
  <div mat-dialog-content>
    <p>{{data.description}}</p>
  </div>
</div>
